import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { formatDate } from "../../lib/utils";

export default function LeadActivityTab({ activity, note, setNote, onAddNote }) {
  return (
    <div className="mt-4 space-y-3">
      <div className="flex gap-2">
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add a note…" data-testid="note-input" />
        <Button onClick={onAddNote} className="bg-[#0D1B2A] text-white" data-testid="add-note-button">Add</Button>
      </div>
      <ol className="relative border-l-2 border-slate-200 pl-5 space-y-4">
        {activity.map((a) => (
          <li key={a.id}>
            <span className="absolute -left-[7px] w-3 h-3 rounded-full bg-[#1A7F6E] mt-1.5" />
            <div className="flex justify-between gap-2">
              <p className="text-sm text-[#0D1B2A]">
                <span className="font-medium">{a.actor_name || a.actor_email}</span> — {a.text}
              </p>
              <span className="text-xs text-slate-500 whitespace-nowrap">{formatDate(a.at)}</span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
